var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_-_Live",
    "data-name": "Icon - Live",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_42",
    "data-name": "Ellipse 42",
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    fill: "#4ed5e6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "stream_FILL0_wght400_GRAD0_opsz24",
    d: "M81.8-869.2a1.733,1.733,0,0,1-1.271-.529A1.733,1.733,0,0,1,80-871a1.733,1.733,0,0,1,.529-1.271A1.733,1.733,0,0,1,81.8-872.8a1.733,1.733,0,0,1,1.271.529A1.733,1.733,0,0,1,83.6-871a1.733,1.733,0,0,1-.529,1.271A1.733,1.733,0,0,1,81.8-869.2Zm1.485,5.13-1.26-1.26,3.915-3.915,1.26,1.26Zm2.7-8.73-3.915-3.915,1.26-1.26,3.915,3.915ZM89-862a1.733,1.733,0,0,1-1.271-.529A1.733,1.733,0,0,1,87.2-863.8a1.733,1.733,0,0,1,.529-1.271A1.733,1.733,0,0,1,89-865.6a1.733,1.733,0,0,1,1.271.529A1.733,1.733,0,0,1,90.8-863.8a1.733,1.733,0,0,1-.529,1.271A1.733,1.733,0,0,1,89-862Zm0-14.4a1.733,1.733,0,0,1-1.271-.529A1.734,1.734,0,0,1,87.2-878.2a1.733,1.733,0,0,1,.529-1.271A1.733,1.733,0,0,1,89-880a1.733,1.733,0,0,1,1.271.529A1.733,1.733,0,0,1,90.8-878.2a1.734,1.734,0,0,1-.529,1.271A1.733,1.733,0,0,1,89-876.4Zm3.015,3.645-1.26-1.305,3.96-3.915,1.26,1.26Zm2.7,8.685L90.8-867.985l1.26-1.26,3.915,3.915ZM96.2-869.2a1.733,1.733,0,0,1-1.271-.529A1.733,1.733,0,0,1,94.4-871a1.733,1.733,0,0,1,.529-1.271A1.733,1.733,0,0,1,96.2-872.8a1.733,1.733,0,0,1,1.271.529A1.733,1.733,0,0,1,98-871a1.733,1.733,0,0,1-.529,1.271A1.733,1.733,0,0,1,96.2-869.2Z",
    transform: "translate(-71 889)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/Icon5.99b8c64f4217d6b67292b73f5d4c40b1.svg";
export { ForwardRef as ReactComponent };